import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class WebsiteTextService extends BaseService {

    static url = "website_text";
    static apis = {
        getAll: { path: this.url, method: "get" },
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("website_text");
    }

    getAll() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: WebsiteTextService.apis.getAll.path,
                    method: WebsiteTextService.apis.getAll.method,
                    authorization: false,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

}

export default WebsiteTextService;